// This has emptied out results i.e. is static
const STATIC_FLAT_RESULTS_URL = 'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_primary/republic_json/results_FLAT_static.json';

// Results from the Secretary of State
const FLAT_RESULTS_URL = 'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_primary/republic_json/results_FLAT.json';

// Includes fake results data for testing
const FAKE_RESULTS_URL = 'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_primary/republic_json/results_FLAT_sample_results.json';
const FAKE_RESULTS_URL_TWO = 'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_primary/republic_json/results_FLAT_Feb26_TEST.json';

// Used for homepage takeover
const HOMEPAGE_URL =
'https://s3.amazonaws.com/sos.texastribune.org/top-news/2020-primary.json';

// Calls TT stories using the API
const STORY_API_URL = (id: number): string =>
  `https://www.texastribune.org/api/v2/content/${id}/?format=json&fields=lead_art,short_summary,url,homepage_headline&__=${+new Date()}`;

// What we are using across the ap
// will be used on the results page, in the homepage takeover
// and in the embeds
const RESULTS_IN_USE = FLAT_RESULTS_URL

export {
  RESULTS_IN_USE,
  HOMEPAGE_URL,
  STORY_API_URL,
};
